<template>
    <div class="app-header">
        <el-row :gutter="20">
            <el-col :md="12" :sm="10"> <img  src="@/assets/img/new_logo_big.png" alt="logo" class="menu-header-img desktop_logo" width="230px"></el-col>
            <el-col :md="12" :sm="14" style="text-align: right"><h2>Подписание документов по ЭЦП</h2></el-col>
        </el-row>
    </div>

</template>

<script>
    export default {
        name: "headerMain",
    }
</script>

<style scoped>
.app-header{
    padding: 20px 20px 0 20px;
    /*height: 72px;*/
}
    @media (max-width: 460px) {
        h2{
            font-size: 16px;
        }
    }
</style>
